import { render } from "./Statistics.vue?vue&type=template&id=e4429292&scoped=true&ts=true"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"

import "./Statistics.vue?vue&type=style&index=0&id=e4429292&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4429292"]])

export default __exports__